import { RolesEnum, RoutesEnum } from "../shared/utils/RoutesEnum";
import config from './config.json';

export const headerList=[
  {
    title: 'revenueManager',
    icon: 'bi bi-graph-up',
    subMenu: null,
    path: RoutesEnum.RevenueManager,
    role: [RolesEnum.AdminRole,  RolesEnum.EditorRole, RolesEnum.ViewerRole],
    isEnabled:config.revenueManager.enabled

  },
]
